import { createFileRoute } from "@tanstack/react-router";

import { parsePartnersSearch } from "@/features/growth";
import { PartnersPage } from "@/features/growth/pages";
import { strictSearch } from "@/shared/lib/search";

/** Referral partners: hg-auth's holders of the `partner` role. */
export const Route = createFileRoute("/_app/growth/partners")({
  validateSearch: strictSearch(parsePartnersSearch),
  component: Partners,
});

function Partners() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <PartnersPage
      search={search}
      onSearchChange={(next, options) =>
        void navigate({ search: next, replace: options?.replace === true })
      }
    />
  );
}
